<template>
  <div class="home">
    <h1>Gym Diary</h1>
    <h2 v-if="userInfo.name"><span>for</span> {{ userInfo.name }}</h2>
    <span>Version {{ $storage.version }}</span>
  </div>
</template>

<script>
export default {
  name: "Home",
  computed: {
    userInfo() {
      return this.$storage._userInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
}
h2 {
  text-align: center;
  & span {
    font-size: 16px;
  }
}
</style>
